import { Box, Card, CardContent, Skeleton, Typography } from '@mui/material';
import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
	selectOrderDiscounts,
	selectOrderDiscountsData,
	selectOrderDiscountsLoading,
	selectOrderDiscountBreakdownData,
	selectOrderDiscountBreakdownLoading,
} from 'redux/reducers/orderManagement/selectors';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import { TOrderDiscountItem } from 'redux/reducers/orderManagement/types';
import { TOrderDiscountsProps } from './types';
import { OrderDiscountsItem } from './OrderDiscountsItem';
import { EasCard } from '../../../../ui/EasCard';

export const OrderDiscounts: FC<TOrderDiscountsProps> = ({ paymentCurrency }) => {
	const orderDiscounts = useSelector(selectOrderDiscounts);
	const orderDiscountsRows = useSelector(selectOrderDiscountsData) as TOrderDiscountItem[];
	const orderDiscountsLoading = useSelector(selectOrderDiscountsLoading);

	const orderDiscountBreakdownRows = useSelector(selectOrderDiscountBreakdownData);
	const orderDiscountBreakdownLoading = useSelector(selectOrderDiscountBreakdownLoading);

	const totalDiscountAmount = useMemo<number>(() => {
		return orderDiscountsRows.reduce(
			(accumulator: number, item: TOrderDiscountItem) =>
				accumulator + (item.total_discount_amount ?? 0),
			0,
		);
	}, [orderDiscountsRows]);

	if (orderDiscountsLoading || orderDiscountBreakdownLoading) {
		return <Skeleton variant="rectangular" height="300px" sx={{ borderRadius: '12px', mb: 2 }} />;
	}

	if (!orderDiscounts || !orderDiscountsRows.length) {
		return null;
	}

	return (
		<EasCard
			id="order-discounts-card"
			title={`Discounts (${orderDiscountsRows.length})`}
			action={<></>}
			loading={orderDiscountsLoading || orderDiscountBreakdownLoading}
		>
			<Typography variant="h6" component="div">
				{orderDiscountsRows.map((item) => (
					<OrderDiscountsItem
						key={item.id}
						orderDiscountItem={item}
						orderDiscountBreakdown={orderDiscountBreakdownRows.filter(
							(i) => i.discount_id === item.id && i.timestamp_year === item.timestamp_year,
						)}
						paymentCurrency={paymentCurrency}
					/>
				))}
			</Typography>

			{/* {orderDiscountsRows.length > 1 && (
					<Box
						sx={{
							mt: 1.5,
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							border: '1px solid #00000020',
							borderRadius: '12px',
							padding: '10px',
						}}
					>
						<Typography variant="h6" sx={{ fontWeight: 'bold' }} color="primary">
							Total Discount Amount:
						</Typography>
						<AmountAndCurrency
							amount={totalDiscountAmount ?? 0}
							currency={paymentCurrency}
							bold="bold"
							size={1.3}
							color="primary"
						/>
					</Box>
				)} */}
		</EasCard>
	);
};
